var $ = jQuery;
$( document ).ready(function() {
    /**
    *  BEGIN Close menu
    */
//     $('.header_overlay').click(function(e) {
//       $('#menu').prop('checked', false);
//     });
    /**
    *  END close menu
    */


     var currentUrlFull = window.location.href;
     if (currentUrlFull.includes('#')) {
          $('html, body').animate({
               scrollTop: $(window.location.hash).offset().top - 100
          }, 'slow');
     } 

    /**
    *  BEGIN sticky menu & Back to top
    */
     $backtotopBtn = $('.backtotop')
     $header = $('.header')

     $header.next().addClass('top-fix--js');
     $("#to_top").click(function () {
          $("html, body").animate({scrollTop: 0}, 500);
     });
    /**
    *  END sticky menu & Back to top
    */

    /**
    *  BEGIN smoothscrool
    */
     // $('a').on('click', function () {
     //      var link = $(this).attr('href');
     //      var linkCheck = link.includes('#');
     //      var targetUrl = link.split('#')[0] + '/';
     //      var currentUrlFull = window.location.href;
     //      var currentUrl = currentUrlFull.split('#')[0];
     //      if (linkCheck) {
     //           if (link.startsWith('#')) {
     //                console.log('test 1');
     //                $('html, body').animate({
     //                     scrollTop: $(link).offset().top - 200
     //                }, 'slow');
     //           } else if(targetUrl === currentUrl){
     //                console.log('test 3.5');
     //                if (this.hash !== "") {
     //                     event.preventDefault();
     //                     var hash = this.hash;
     //                     $('html, body').animate({
     //                       scrollTop: $(hash).offset().top - 200
     //                     }, 'slow' );
     //                };
     //           }
     //           else if(targetUrl !== currentUrl){
     //                console.log('test 2 ' + currentUrl + ' --- ' + targetUrl );
     //                $('html, body').animate({
     //                     scrollTop: $(window.location.hash).offset().top - 200
     //                }, 'slow');
     //                return false;
     //           } 

     //           else {
     //                console.log('test 4');
     //                if (this.hash !== "") {
     //                     event.preventDefault();
     //                     var hash = this.hash;
     //                     $('html, body').animate({
     //                       scrollTop: $(hash).offset().top - 200
     //                     }, 'slow' );
     //                };
     //           } 
     //      }
     // }).stop();




     $('a').on('click', function () {
          var link = $(this).attr('href');
          var linkCheck = link.includes('#');
          if (linkCheck) {
               if (link.startsWith('#')) {
                    $('html, body').animate({
                         scrollTop: $(link).offset().top - 200
                    }, 'slow');
               }
          }
     }).stop();

     /**
      *  END smoothscrool
      */

    var Menu = {
        
  
     setDropdownButtons: (menuID, linkClass, dropdownButtonClass) => {
       let 
         menu = document.getElementById(menuID),
         dropdownItems = menu.querySelectorAll(linkClass);

       dropdownItems.forEach(item => item.innerHTML += '<button class="'+ dropdownButtonClass +'">+</button>');
     },

     toggleDropdown: (dropdownClass) => {
       let dropdownButton = document.querySelectorAll(dropdownClass);

       dropdownButton.forEach(element => {
         element.addEventListener('click', (event) => {
           event.preventDefault();
           let dropdownList = element.parentElement.nextSibling;
           dropdownList.classList.toggle('active');
           if(dropdownList.classList.contains('active')) {
             dropdownList.style.maxHeight = dropdownList.scrollHeight + 'px';
           } else {
             dropdownList.style.removeProperty('max-height');
           }
         });
       });
     },
 
     /**
      * Responsive menu animations
      */
     toggleNavigation: (buttonID = 'toggleNavigation', menuID = 'header') => {
         let 
           button = document.getElementById(buttonID),
           header = document.getElementById(menuID);
         
         button.addEventListener('click', () => {
           button.classList.toggle('active');
           header.classList.toggle("opened");
         });
     }
 }

 $(function() {
     document.querySelector('html').classList.remove('no-js');
     Menu.toggleNavigation();
   });



    /**
    *  BEGIN Menu add & remove Class for the submenu
    */
     $('<a class="cross-submenu-js"></a>').appendTo('li.menu-item-has-children > a');

     $('li.menu-item-has-children').hover(function() {
          var isHovered = $(this).is(":hover");
          if (isHovered) {
               $(this).children("ul").stop().slideDown(300);
          } else {
               $(this).children("ul").stop().slideUp(300);
          }
     });
     $('.cross-submenu-js').on('click', function() {
          event.preventDefault();
     });
   /* 
     END Menu add & remove Class for the submenu
   */

     
    /**
    *  BEGIN Custom radio button
    */
   var idIncrement = 0;
   var forIncrement = 0;

    $('input[type=radio]').each(function() {
      idIncrement++;
      $(this).attr('id', 'custom_btn-' + idIncrement);
    });

    $('input[type=radio] + span').each(function() {
      forIncrement++;
      $(this).replaceWith("<label class='wpcf7-list-item-label' for='custom_btn-"+forIncrement+"'> " + $(this).text() + "</label>");
    });
    /* 
      END Custom radio button
    */
});